export default Object.freeze([
	{ label: 'Return to sender', value: 'Return' },
	{ label: 'Treat as abandoned', value: 'Abandon' },
]);
